import request from '@/utils/request'

export function getCollegeList(query) {
  return request({
    url: '/index/colleges/getList',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}


